export enum PaymentStepState
{
    Awaiting = "Awaiting",
    Paid = "Paid",
    Canceled = "Canceled",
    Omitted = "Omitted",
    Error = "Error",
    Returned = "Returned",
    UnableToExecute = "UnableToExecute",
}


export const PaymentStepStateLabels: Record<string, PaymentStepState> = {
    "Czeka": PaymentStepState.Awaiting,
    "Opłacone": PaymentStepState.Paid,
    "Odwołane": PaymentStepState.Canceled,
    "Pominięte": PaymentStepState.Omitted,
    "Błąd": PaymentStepState.Error,
    "Zwrócone": PaymentStepState.Returned,
    "Nie można wykonać": PaymentStepState.UnableToExecute,
}
